import React from 'react';

import type { TaskShape } from '../../types';

import { ActiveTask } from './components/ActiveTask';
import { CompletedTask } from './components/CompletedTask';

type TaskProps = TaskShape;
export const Task: React.FC<TaskProps> = (props) => {
	const { status, name, isFirstActive = false, ...rest } = props;

	// Don't render IGNORED tasks
	if (status === 'IGNORED') return null;

	const renderTaskContent = () => {
		// TODO: Other state tasks go here
		switch (status) {
			case 'ACTIVE': {
				return <ActiveTask name={name} isFirstActive={isFirstActive} {...rest} />;
			}
			case 'COMPLETED':
				return <CompletedTask name={name} {...rest} />;
			default:
				return null;
		}
	};

	return <div className="group hover:bg-fill-inverse-weak transition-colors duration-100">{renderTaskContent()}</div>;
};
